/*eslint-disable */

export function getAllLegalfirm(state) {
    return state.items;
}

